// Dictionary, 843 part 1 — the 843-specific beginning segment: BQR
// (Beginning Segment for Response to Request for Quotation). Generic X12
// 843 (005010) definitions only; not tied to any trading partner's
// implementation guide.
//
// Everything else the 843 header body, its Name (N1) loop and its
// quoted-item loop use — CUR, REF, PER, FOB, ITD, DTM, N1-N9 (in
// dictionary/header-segments.ts), PO1, PID, MEA, CTP, SAC, SDQ (in
// dictionary/item-loop-segments.ts) — is a segment X12 defines once and
// reuses across transaction sets, so it's already defined elsewhere and
// merged in by index.ts. This file does not redefine any of them.

import {LoopId, type ElementDefinition, type SegmentDefinition} from './types';
import {TRANSACTION_SET_PURPOSE_CODES} from './transaction-set-purpose-codes';

function el(
  position: number,
  label: string,
  description: string,
  extra: Partial<ElementDefinition> = {}
): ElementDefinition {
  return {position, label, description, ...extra};
}

export const SEGMENTS_843: Record<string, SegmentDefinition> = {
  BQR: {
    id: 'BQR',
    name: 'Beginning Segment for Response to Request for Quotation',
    purpose:
      'Identifies the quote number this response covers and what kind of response this is. Required at the start of every 843.',
    loop: LoopId.Header,
    required: true,
    elements: [
      el(
        1,
        'Transaction Set Purpose Code',
        'Whether this is an original response, a change, a replacement, etc.',
        {
          dataType: 'code',
          required: true,
          codes: TRANSACTION_SET_PURPOSE_CODES,
        }
      ),
      el(2, 'Reference Identification', 'The quote number this responds to.', {
        required: true,
      }),
      el(3, 'Date', 'Date the quote response was prepared.', {
        dataType: 'date',
        format: 'CCYYMMDD',
        required: true,
      }),
      el(
        4,
        'Request Reference Number',
        'A reference number the original request was tied to, when applicable.'
      ),
      el(5, 'Contract Number', 'A related contract number, when applicable.'),
    ],
  },
};
